import { useState, TouchEvent, useEffect } from 'react';

export const HANDLE_WIDTH = 56;

export type SlideBarStatus = 'idle' | 'dragging' | 'complete';

interface Props {
    containerWidth: number;
    onConfirm?: () =>void;
}

function useSlideHandle({ containerWidth, onConfirm }:Props) {
    const [translateX, setTranslateX] = useState<number>(0);
    const [startX, setStartX] = useState<number>(0);
    const [status, setStatus] = useState<SlideBarStatus>('idle');
    const percent = translateX / (containerWidth);
    const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
        const { clientX } = e.touches[0];
        setStartX(clientX);
        setStatus('dragging');
    };
    const handleTouchMove = (e: TouchEvent<HTMLDivElement>) => {
        const { clientX } = e.touches[0];
        const newValue = clientX - startX;
        if (newValue >= 0 && newValue < containerWidth - HANDLE_WIDTH) {
            setTranslateX(newValue);
        }
    };

    const handleTouchEnd = () => {
        if (percent > 0.8) {
            setStatus('complete');
            setTranslateX(containerWidth - HANDLE_WIDTH);
            onConfirm?.();
            const resetTimeout = setTimeout(() => {
                setTranslateX(0);
            }, 1000);
            const resetTimeout2 = setTimeout(() => {
                setStatus('idle');
            }, 1100);
            return () => {
                clearTimeout(resetTimeout);
                clearTimeout(resetTimeout2);
            };
        }
        setStatus('dragging');

        setTranslateX(0);
        return () => {};
    };
    return {
        percent,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        status,
        translateX,
    };
}

export default useSlideHandle;
